export default __webpack_public_path__ + "img/gfx_features_at_a_glance-d1198f93a26af50c63bf8779006daa33.png";